import React from 'react'
import { TEXT_UI_MISC } from 'config'

export default () => <div className="ta-center p-t-30 p-b-30">{TEXT_UI_MISC.NO_DATA_AVAILABLE}</div>
